import React, { useEffect } from "react";
import Navbar from "./Navbar";
import "./banner.css";

import Banner1 from "../assets/images/banner1.png";
import Banner2 from "../assets/images/banner2.png";
import Banner3 from "../assets/images/banner3.png";
import Banner4 from "../assets/images/banner4.png";
import Banner5 from "../assets/images/banner5.png";
import Banner6 from "../assets/images/banner6.png";

import { Link } from "react-router-dom";

import BannerBg1 from "../assets/images/banner-bg-1.png";

import AOS from "aos";
import "aos/dist/aos.css";

const Banner = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <div className="banner" id="home">
        <div className="banner-watermark"></div>
        <div className="container-fluid">
          <div className="banner-content">
            <div className="row">
              <div className="col-md-7">
                <div
                  className="left-sec"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <div className="main-heading">
                    {/* <h1>
                      <span class="waviy">
                        <span style={{ "--i": 1 }}>L</span>
                        <span style={{ "--i": 2 }}>e</span>
                        <span style={{ "--i": 3 }}>a</span>
                        <span style={{ "--i": 4 }}>r</span>
                        <span style={{ "--i": 5 }}>n</span>
                      </span>
                      , &nbsp;
                      <span class="waviy">
                        <span style={{ "--i": 1 }}>I</span>
                        <span style={{ "--i": 2 }}>n</span>
                        <span style={{ "--i": 3 }}>t</span>
                        <span style={{ "--i": 4 }}>e</span>
                        <span style={{ "--i": 5 }}>r</span>
                        <span style={{ "--i": 6 }}>a</span>
                        <span style={{ "--i": 7 }}>c</span>
                        <span style={{ "--i": 8 }}>t</span>
                      </span>
                      &nbsp; and &nbsp; <br />
                      <span class="waviy">
                        <span style={{ "--i": 1 }}>E</span>
                        <span style={{ "--i": 2 }}>v</span>
                        <span style={{ "--i": 3 }}>a</span>
                        <span style={{ "--i": 4 }}>l</span>
                        <span style={{ "--i": 5 }}>u</span>
                        <span style={{ "--i": 6 }}>a</span>
                        <span style={{ "--i": 7 }}>t</span>
                        <span style={{ "--i": 8 }}>e</span>
                      </span>
                      &nbsp; to improve your learning skills
                    </h1> */}

                    <h1>
                    Learn, Interact and Evaluate
                    </h1>
                  </div>
                  <div className="main-para">
                    <p>
                      Unleash the power of E- learning anywhere, anytime with
                      our interactive engaging E-learning course
                    </p>
                  </div>
                  <div className="main-cta">
                    <Link to="/request">
                      <button className="btn btn-danger">Get Started</button>
                    </Link>

                    <a href="#contact">
                      <button className="btn btn-dark">Contact Us</button>
                    </a>
                  </div>
                  <div className="fancy-text">
                    <div className="icon">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="37"
                          height="41"
                          viewBox="0 0 52.572 58.556"
                        >
                          <path
                            id="Untitled-1"
                            d="M10.563,1.8l-.3.066-.313.082-.346.1-.363.1-.379.115-.4.132-.429.148L7.595,2.7l-.462.165-.478.181-.495.181-.528.2-.544.2-.561.2-.577.214-.594.214-.627.214-.643.214A.886.886,0,0,1,1.527,3l.627-.214.61-.214.594-.214.577-.2.561-.2.544-.2.528-.2.511-.181L6.572,1.2l.478-.165L7.512.874,7.957.725,8.386.577,8.8.445l.4-.115.379-.1L9.953.148l.363-.066.346-.049L11.008,0h.66L12,.049l.313.082.313.115.3.165.264.2.231.247.2.28.165.3.132.33.115.346.082.363.066.4.049.412v.445l.033.478v.511l-.049.544-.049.577-.066.61-.082.643-.1.693-.115.725-.132.775-.132.808-.148.857-.165.907a.831.831,0,1,1-1.632-.313l.165-.89.148-.841.132-.791.115-.758.1-.709.082-.66.066-.627.049-.577.033-.528V4.666l.033-.445V3.809l-.033-.363-.033-.33-.049-.28h0l-.132.148-.725.841-.709.857-.676.89-.66.907L8.848,7.4l-.61.94L7.644,9.3l-.561.973-.544.973-.511.989L5.55,13.24l-.462,1.022L4.66,15.285l-.412,1.039-.379,1.039-.346,1.055-.313,1.055-.3,1.072-.264,1.072-.231,1.072-.2,1.072-.165,1.072L1.923,25.92l-.1,1.088L1.758,28.1l-.033,1.088v1.072l.033,1.072L1.824,32.4l.1,1.072.132,1.055.165,1.055.214,1.055.247,1.039.28,1.039.313,1.022.363,1.006.4,1.006.429.989.478.973.511.956.561.94.594.923.643.907.676.89.725.874.775.874.709.775.709.791.709.791.725.791L13,54l.758.742.379.346.379.346.4.33.4.33.4.313.412.3.412.28.429.264.429.247.445.231.445.214.478.2a.836.836,0,1,1-.627,1.55l-.511-.214-.511-.247-.495-.264-.495-.28-.478-.3-.462-.313-.445-.33-.445-.346-.429-.346-.412-.363-.412-.379-.412-.379-.775-.775-.758-.791-.742-.808-.725-.791-.709-.791L8.2,51.2,7.4,50.29l-.775-.923L5.9,48.41l-.676-.973-.643-.989-.594-1.006L3.44,44.42l-.511-1.039-.462-1.039-.429-1.055-.379-1.072-.346-1.072-.3-1.088-.264-1.1-.214-1.1-.181-1.1L.208,33.62.109,32.5.043,31.377.01,30.24V29.1l.033-1.138.066-1.138.1-1.138L.34,24.551l.181-1.138.214-1.121.231-1.121L1.23,20.05l.3-1.1.33-1.1.363-1.1.4-1.088.412-1.088.445-1.072.478-1.055.511-1.039.528-1.039L5.55,9.332l.577-1.006.61-.989.643-.973.66-.956.693-.94.709-.923.725-.907.758-.874.066-.082h-.2l-.264.066Z"
                            transform="matrix(0.777, -0.629, 0.629, 0.777, -0.008, 12.131)"
                            fill="#d4d4d4"
                          />
                        </svg>
                      </span>
                    </div>
                    <div className="text">
                      <span>Let's start your journey here!</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <div className="right-sec">
                  <div
                    className="right-sec-flex"
                    data-aos="fade-up"
                    data-aos-duration="1500"
                  >
                    <div className="flex flex1">
                      <img src={Banner1} alt="" />
                      <img src={Banner3} alt="" />
                      <img src={Banner5} alt="" />
                    </div>
                    <div className="flex flex2">
                      <img src={Banner2} alt="" />
                      <img src={Banner4} alt="" />
                      <img src={Banner6} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
